// @ts-nocheck
import { LICENSE_LIST_ERROR, LICENSE_LIST_LOADING, LICENSE_LIST_SUCCESS} from "../../Action/Type";

const initialState = {
    payload: {},
    loading: false,
    error: ''
}

export const LicenseListReducer = (state = initialState, action) => {
    switch (action.type) {
        case LICENSE_LIST_LOADING:
            return Object.assign({}, state, { loading: true })
        case LICENSE_LIST_SUCCESS:
            return Object.assign({}, state, { payload: action.data, loading: false })
        case LICENSE_LIST_ERROR:
            return Object.assign({}, state, { payload: action.data, loading: false })
        default:
            return state
    }
}

